export default __webpack_public_path__ + "static/mobile-small-1.5x-72b203eaced6a197cf532df1a6ce8ebc.jpeg";